export const CopyIcon = ({ size = 20, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M13.334 10.75v3.5c0 2.917-1.167 4.083-4.084 4.083h-3.5c-2.916 0-4.083-1.166-4.083-4.083v-3.5c0-2.917 1.167-4.083 4.083-4.083h3.5c2.917 0 4.084 1.166 4.084 4.083"
      stroke="#aab3d0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.334 5.75v3.5c0 2.917-1.167 4.083-4.084 4.083h-.916V10.75c0-2.917-1.167-4.083-4.084-4.083H6.667V5.75c0-2.917 1.167-4.083 4.083-4.083h3.5c2.917 0 4.084 1.166 4.084 4.083"
      stroke="#aab3d0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
